// extracted by mini-css-extract-plugin
export default {"rating":"styles_rating__+TCCn","stars":"styles_stars__AmdHx"};